// extracted by mini-css-extract-plugin
module.exports = {"recordcamera":"recordcamera_recordcamera__mU4Wl","preview":"recordcamera_preview__1TUQO","actions":"recordcamera_actions__2qCZt","button":"recordcamera_button__BmuTU"};